import React from "react";
import { Grid, Typography } from "@material-ui/core";
import { getLocalizedString } from "@icarius-localization/strings";

const ContainerTitle = ({ title, variant, variantAction, customItem }) => {

  return (
    <Grid container alignItems='center' justify='space-between' style={{ paddingTop: 10, paddingLeft: 20, paddingRight: 20 }}>
      <Typography className="whiteText" style={{ fontSize: 25, fontWeight: 500 }}>
        {title}
      </Typography>
      {
        variant &&
        <Typography
          onClick={variantAction} className="whiteText"
          style={{ cursor: 'pointer', textDecoration: 'underline', fontSize: 16, fontWeight: 500 }}
        >
          {getLocalizedString("seeAll")}
        </Typography>
      }
      {customItem}
    </Grid>
  )
}

export default ContainerTitle;